"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var parseData = function (stats) {
    var data = [
        {
            key: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/startedJobs'),
            value: stats.started_jobs,
            color: '#6324B040',
            height: ''
        },
        {
            key: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/ongoingJobs'),
            value: stats.ongoing_jobs,
            color: '#6324B08C',
            height: ''
        },
        {
            key: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/completedJobs'),
            value: stats.completed_jobs,
            color: '#6324B0',
            height: ''
        },
        {
            key: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/discontinuedJobs'),
            value: stats.discontinued_jobs,
            color: '#909090',
            height: ''
        }
    ];
    return data;
};
var BarChart = function (props) {
    if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'loading' },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    else if (props.status === 'FAILED' || props.stats === undefined) {
        return (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-entries", key: "no-entries", title: "diaryEntriesView/emptyList/title", message: "diaryEntriesView/emptyList/message" }));
    }
    var data = parseData(props.stats);
    var max = Math.max.apply(Math, data.map(function (d) { return d.value; }));
    data.forEach(function (d) { return (d.height = "".concat(((d.value / max) * 100).toFixed(0), "%")); });
    return (React.createElement("div", { className: "worksite-status-container" },
        React.createElement("div", { className: "worksite-status" }, data.map(function (d) {
            return (React.createElement("div", { key: d.key, className: "status-entry" },
                React.createElement("div", { className: "status-bar", style: { background: d.color, height: d.height } }),
                React.createElement("div", { className: "status-value" }, d.value)));
        })),
        React.createElement("div", { className: "status-axis" }),
        React.createElement("div", { className: "worksite-legend" }, data.map(function (d) {
            return (React.createElement("div", { key: d.key, className: "status-entry" },
                React.createElement("div", { className: "status-key" }, d.key)));
        }))));
};
exports.default = BarChart;
